import { Component } from '@angular/core';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxScrollTopModule } from 'ngx-scrolltop';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { AdmissionProcedureComponent } from './components/pages/admission-procedure/admission-procedure.component';
import { ArtsComponent } from './components/pages/arts/arts.component';
import { AutismComponent } from './components/pages/autism/autism.component';
import { ContactUs } from './components/pages/contact/contact.component';
import { CulturalComponent } from './components/pages/cultural/cultural.component';
import { ECDP } from './components/pages/ecdp/ecdp.component';
import { EducationSystem } from './components/pages/education-system/education-system.component';
import { facilities } from './components/pages/facilities/facilities.component';
import { FuturePlanComponent } from './components/pages/future-plan/future-plan.component';
import { GoverningBody } from './components/pages/governing-body/governing-body.component';
import { HearingComponent } from './components/pages/hearing/hearing.component';
import { history } from './components/pages/history/history.component';
import { Home } from './components/pages/home/home.component';
import { IdComponent } from './components/pages/id/id.component';
import { MeeComponent } from './components/pages/mee/mee.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { NoticeComponent } from './components/pages/notice/notice.component';
import { NutritionComponent } from './components/pages/nutrition/nutrition.component';
import { OngoingProjectsComponent } from './components/pages/ongoing-projects/ongoing-projects.component';
import { OrgstrutureComponent } from './components/pages/orgstruture/orgstruture.component';
import { OT } from './components/pages/ot/ot.component';
// import { FolderListComponent } from './components/pages/photos/folder-list/folder-list.component';
// import { ImageListComponent } from './components/pages/photos/image-list/image-list.component';
import { PpsComponent } from './components/pages/pps/pps.component';
import { PsychologyComponent } from './components/pages/psychology/psychology.component';
import { PTS } from './components/pages/pts/pts.component';
import { SLT } from './components/pages/slt/SLT.component';
import { SportsComponent } from './components/pages/sports/sports.component';
import { TherapistComponent } from './components/pages/therapist/therapist.component';
import { VolunteerComponent } from './components/pages/volunteer/volunteer.component';
import { TeacherAssistantComponent } from './components/pages/teacherassistant/teacherassistant.component';
import{ AssistantComponent } from './components/pages/assistant/assistant.component';
import { StaffsComponent } from './components/pages/staffs/staffs.component';
import { TeachersComponent } from './components/pages/teachers/teachers.component';
import { underConstruction } from './components/pages/underConstrction/underConstruction.component';
import { VideosComponent } from './components/pages/videos/videos.component';
import { VS } from './components/pages/vs/vs.component';
import { MessagesComponent } from './components/pages/messages/messages.component';
import { MessageOneComponent } from './components/pages/message-one/message-one.component';
import { MessageTwoComponent } from './components/pages/message-two/message-two.component';
import { VolunteerServiceComponent } from './components/pages/volunteer-service/volunteer-service.component';
import { MessageThreeComponent } from './components/pages/message-three/message-three.component';
import { MessageFourComponent } from './components/pages/message-four/message-four.component';
import { ItComponent } from './components/pages/it/it.component';
import { ModalComponent } from './components/layouts/modal/modal.component';
import { InclusionComponent } from './components/pages/inclusion/inclusion.component';
import { InclusionFrobelComponent } from './components/pages/inclusion-frobel/inclusion-frobel.component';
import { InclusionEisComponent } from './components/pages/inclusion-eis/inclusion-eis.component';
import { InlusionCgsComponent } from './components/pages/inlusion-cgs/inlusion-cgs.component';
import { EventsZooComponent } from './components/pages/events-zoo/events-zoo.component';
import { EventsUtshabComponent } from './components/pages/events-utshab/events-utshab.component';
import { EventsEuphoriaComponent } from './components/pages/events-euphoria/events-euphoria.component';
import { EventsBirthdayComponent } from './components/pages/events-birthday/events-birthday.component';
import { EventsPaitingComponent } from './components/pages/events-paiting/events-paiting.component';
import { EventsFatherComponent } from './components/pages/events-father/events-father.component';
import { EventsKamalComponent } from './components/pages/events-kamal/events-kamal.component';
import { EventsMldComponent } from './components/pages/events-mld/events-mld.component';
import { EventsSportsComponent } from './components/pages/events-sports/events-sports.component';
import { EventsOtComponent } from './components/pages/events-ot/events-ot.component';
import { EventsAcpComponent } from './components/pages/events-acp/events-acp.component';
import { EventsUcepComponent } from './components/pages/events-ucep/events-ucep.component';
import { EventsMadamComponent } from './components/pages/events-madam/events-madam.component';
import { EventsTapComponent } from './components/pages/events-tap/events-tap.component';
import { JournalComponent } from './components/pages/Journal/journal';
import { HttpClientModule } from '@angular/common/http';
import { EmitterService } from './EmitterService';
import { AppService } from './app.service';
import { AdministrativeBodyComponent } from './components/pages/administrative-body/administrative-body.component';
// import {VolunteerComponent} from './components/pages/volunteer/volunteer.component';
import { LayoutImageListComponent } from './components/layouts/layout-image-list/layout-image-list.component';
import { LayoutImageSingleComponent } from './components/layouts/layout-image-single/layout-image-single.component';
import { LayoutDocumentSingleComponent } from './components/layouts/layout-document-single/layout-document-single.component';
import { LayoutImageMultipleComponent } from './components/layouts/layout-image-multiple/layout-image-multiple.component';
import { LayoutDocumentListComponent } from './components/layouts/layout-document-list/layout-document-list.component';
import { TemplatePageComponent } from "./components/pages/template-page/template-page.component";
import { AdministrationComponent } from "./components/pages/administration/administration.component";
import { ImageGalleryComponent } from './components/pages/image-gallery/image-gallery.component';
import { ImageFolderComponent } from './components/pages/image-folder/image-folder.component';
import { VideoGalleryComponent } from './components/pages/video-gallery/video-gallery.component';
import { VideoFolderComponent } from './components/pages/video-folder/video-folder.component';
import { SafePipe } from './utils/safe.pipe';
import { TemplateTwoComponent } from './components/pages/template-two/template-two.component';
import { LayoutDocumentSingleTwoComponent } from './components/layouts/layout-document-single-two/layout-document-single-two.component';
import { InclusionItemComponent } from './components/pages/inclusion-item/inclusion-item.component';
import { NewAndEventsComponent } from './components/pages/new-and-events/new-and-events.component';
import { NewAndEventsItemsComponent } from './components/pages/new-and-events-items/new-and-events-items.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServicesItemComponent } from './components/pages/services-item/services-item.component';
import { ELibraryComponent } from './components/pages/e-library/e-library.component';
import { FolderListComponent } from './components/pages/photos/folder-list/folder-list.component';
import { ImageListComponent } from './components/pages/photos/image-list/image-list.component';
import { ELibraryItemsComponent } from './e-library-items/e-library-items.component';
import { SpecialEducationComponent } from './components/pages/special-education/special-education.component';
import { StoryComponent } from './components/pages/story/story.component';
import { RhymesComponent } from './components/pages/rhymes/rhymes.component';
import { ScienceComponent } from './components/pages/science/science.component';
import { EducationComponent } from './components/pages/education/education.component';
import { IndependenceOfBangladeshComponent } from './components/pages/independence-of-bangladesh/independence-of-bangladesh.component';
import { MedicalScienceComponent } from './components/pages/medical-science/medical-science.component';
import { MathematicsComponent } from './components/pages/mathematics/mathematics.component';
import { EnglishComponent } from './components/pages/english/english.component';
import { EHistoryComponent } from './components/pages/e-history/e-history.component';
import { EPersonalityComponent } from './components/pages/e-personality/e-personality.component';
import { WomenAwakeningComponent } from './components/pages/women-awakening/women-awakening.component';
import { ESportsComponent } from './components/pages/e-sports/e-sports.component';
@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    FooterComponent,
    NotFoundComponent,
    ContactUs,
    Home,
    ECDP,
    PTS,
    OT,
    SLT,
    VS,   
    GoverningBody,
    EducationSystem,
    history,
    facilities,
    underConstruction,
    NavbarComponent,
    CulturalComponent,
    ArtsComponent,
    MeeComponent,
    SportsComponent,
    OngoingProjectsComponent,
    NoticeComponent,
    VideosComponent,
    AdmissionProcedureComponent,
    TherapistComponent, 
    VolunteerComponent,
    TeacherAssistantComponent, 
    AssistantComponent,
    StaffsComponent,
    TeachersComponent,     
    OrgstrutureComponent,
    PsychologyComponent,
    NutritionComponent,
    PpsComponent,
    AutismComponent,
    HearingComponent,
    IdComponent,
    FuturePlanComponent,
    // FolderListComponent,
    // ImageListComponent,
    MessagesComponent,
    MessageOneComponent,
    MessageTwoComponent,
    VolunteerServiceComponent,
    MessageThreeComponent,
    MessageFourComponent,
    ItComponent,
    ModalComponent,
    InclusionComponent,
    InclusionFrobelComponent,
    InclusionEisComponent,
    InlusionCgsComponent,
    EventsZooComponent,
    EventsUtshabComponent,
    EventsEuphoriaComponent,
    EventsBirthdayComponent,
    EventsPaitingComponent,
    EventsFatherComponent,
    EventsKamalComponent,
    EventsMldComponent,
    EventsSportsComponent,
    EventsOtComponent,
    EventsAcpComponent,
    EventsUcepComponent,
    EventsMadamComponent,
    EventsTapComponent,
    JournalComponent,
    AdministrativeBodyComponent,
    TemplatePageComponent, 
    LayoutImageListComponent,
    LayoutImageSingleComponent,
    LayoutDocumentSingleComponent,
    LayoutImageMultipleComponent,
    LayoutDocumentListComponent,
    AdministrationComponent,
    SafePipe,
    ImageFolderComponent,
    ImageGalleryComponent,
    VideoFolderComponent,
    VideoGalleryComponent,
    TemplateTwoComponent,
    LayoutDocumentSingleTwoComponent,
    InclusionItemComponent,
    NewAndEventsComponent,
    NewAndEventsItemsComponent,
    ServicesComponent,
    ServicesItemComponent,
    ELibraryComponent,  
    FolderListComponent,
    ImageFolderComponent,
    ELibraryItemsComponent,
    SpecialEducationComponent,
    StoryComponent,
    RhymesComponent,
    ScienceComponent,
    EducationComponent,
    IndependenceOfBangladeshComponent,
    MedicalScienceComponent,
    MathematicsComponent,
    EnglishComponent,
    EHistoryComponent,
    EPersonalityComponent,
    WomenAwakeningComponent,
    ESportsComponent,
  ],
//   imports: [BrowserModule, AppRoutingModule, NgxScrollTopModule],
//   providers: [],
//   bootstrap: [AppComponent],
// })
// export class AppModule {}
imports: [BrowserModule, AppRoutingModule, NgxScrollTopModule, HttpClientModule],
  providers: [AppService, EmitterService],
  bootstrap: [AppComponent],
})
export class AppModule { }

